import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/users/user1.jpg'
import _imports_1 from '@/assets/images/users/user2.jpg'
import _imports_2 from '@/assets/images/users/user3.jpg'
import _imports_3 from '@/assets/images/users/user4.jpg'
import _imports_4 from '@/assets/images/users/user5.jpg'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-subtitle" }
const _hoisted_4 = { class: "trezo-card-dropdown relative" }
const _hoisted_5 = { class: "trezo-card-content -mx-[20px] md:-mx-[25px]" }
const _hoisted_6 = { class: "table-responsive overflow-x-auto" }
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "text-black dark:text-white" }
const _hoisted_9 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_10 = { class: "flex items-center gap-[9px]" }
const _hoisted_11 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_12 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_13 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_14 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_15 = { class: "flex items-center gap-[9px]" }
const _hoisted_16 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_17 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_18 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_19 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_20 = { class: "flex items-center gap-[9px]" }
const _hoisted_21 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_22 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_23 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_24 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_25 = { class: "flex items-center gap-[9px]" }
const _hoisted_26 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_27 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_28 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}
const _hoisted_29 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_30 = { class: "flex items-center gap-[9px]" }
const _hoisted_31 = {
  type: "button",
  class: "text-primary-500 leading-none custom-tooltip"
}
const _hoisted_32 = {
  type: "button",
  class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
}
const _hoisted_33 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "trezo-card-title" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Latest Transactions")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block transition-all hover:text-primary-500': true,
              active: _ctx.isActive,
            }),
            id: "dropdownToggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]" }, [
              _createTextVNode(" Last 30 Days "),
              _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2" })
            ], -1)
          ]), 2),
          _cache[2] || (_cache[2] = _createElementVNode("ul", { class: "trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[10000] dark:bg-dark dark:shadow-none" }, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, " Last 7 Days ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, " Last 15 Days ")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, " Last 30 Days ")
            ])
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[54] || (_cache[54] = _createElementVNode("thead", { class: "text-black dark:text-white" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "font-normal ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Customer ID "),
              _createElementVNode("th", { class: "font-normal ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Customer Name "),
              _createElementVNode("th", { class: "font-normal ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Property "),
              _createElementVNode("th", { class: "font-normal ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Date "),
              _createElementVNode("th", { class: "font-normal ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Price "),
              _createElementVNode("th", { class: "font-normal ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Status "),
              _createElementVNode("th", { class: "font-normal ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Payment "),
              _createElementVNode("th", { class: "font-normal ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }, " Action ")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_8, [
            _createElementVNode("tr", null, [
              _cache[7] || (_cache[7] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[15px]" }, [
                  _createElementVNode("div", { class: "form-check relative top-[1.5px]" }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "cursor-pointer"
                    })
                  ]),
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #TRE0015 ")
                ])
              ], -1)),
              _cache[8] || (_cache[8] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Sarah Johnson ")
                  ])
                ])
              ], -1)),
              _cache[9] || (_cache[9] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Industrial ")
              ], -1)),
              _cache[10] || (_cache[10] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 30 Apr 2024 ")
              ], -1)),
              _cache[11] || (_cache[11] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " $500,000 ", -1)),
              _cache[12] || (_cache[12] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-success-50 dark:bg-[#15203c] text-success-600 rounded-sm font-medium text-xs" }, " Completed ")
              ], -1)),
              _cache[13] || (_cache[13] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Master Card ")
              ], -1)),
              _createElementVNode("td", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_11, _cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_12, _cache[5] || (_cache[5] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_13, _cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[17] || (_cache[17] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[15px]" }, [
                  _createElementVNode("div", { class: "form-check relative top-[1.5px]" }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "cursor-pointer"
                    })
                  ]),
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #TRE0099 ")
                ])
              ], -1)),
              _cache[18] || (_cache[18] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Michael Smith ")
                  ])
                ])
              ], -1)),
              _cache[19] || (_cache[19] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Office ")
              ], -1)),
              _cache[20] || (_cache[20] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 29 Apr 2024 ")
              ], -1)),
              _cache[21] || (_cache[21] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " $1,200,000 ", -1)),
              _cache[22] || (_cache[22] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-secondary-50 dark:bg-[#15203c] text-secondary-600 rounded-sm font-medium text-xs" }, " Pending ")
              ], -1)),
              _cache[23] || (_cache[23] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Paypal ")
              ], -1)),
              _createElementVNode("td", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_16, _cache[14] || (_cache[14] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_17, _cache[15] || (_cache[15] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_18, _cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[27] || (_cache[27] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[15px]" }, [
                  _createElementVNode("div", { class: "form-check relative top-[1.5px]" }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "cursor-pointer"
                    })
                  ]),
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #TRE0145 ")
                ])
              ], -1)),
              _cache[28] || (_cache[28] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Emily Brown ")
                  ])
                ])
              ], -1)),
              _cache[29] || (_cache[29] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Multi-Family ")
              ], -1)),
              _cache[30] || (_cache[30] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 28 Apr 2024 ")
              ], -1)),
              _cache[31] || (_cache[31] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " $350,000 ", -1)),
              _cache[32] || (_cache[32] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-orange-50 dark:bg-[#15203c] text-orange-600 rounded-sm font-medium text-xs" }, " Cancel ")
              ], -1)),
              _cache[33] || (_cache[33] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Wise ")
              ], -1)),
              _createElementVNode("td", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_21, _cache[24] || (_cache[24] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_22, _cache[25] || (_cache[25] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_23, _cache[26] || (_cache[26] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[37] || (_cache[37] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[15px]" }, [
                  _createElementVNode("div", { class: "form-check relative top-[1.5px]" }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "cursor-pointer"
                    })
                  ]),
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #TRE0247 ")
                ])
              ], -1)),
              _cache[38] || (_cache[38] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Jason Lee ")
                  ])
                ])
              ], -1)),
              _cache[39] || (_cache[39] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Residential ")
              ], -1)),
              _cache[40] || (_cache[40] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 27 Apr 2024 ")
              ], -1)),
              _cache[41] || (_cache[41] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " $220,000 ", -1)),
              _cache[42] || (_cache[42] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-success-50 dark:bg-[#15203c] text-success-600 rounded-sm font-medium text-xs" }, " Completed ")
              ], -1)),
              _cache[43] || (_cache[43] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Payoneer ")
              ], -1)),
              _createElementVNode("td", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_26, _cache[34] || (_cache[34] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_27, _cache[35] || (_cache[35] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_28, _cache[36] || (_cache[36] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _cache[47] || (_cache[47] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center gap-[15px]" }, [
                  _createElementVNode("div", { class: "form-check relative top-[1.5px]" }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "cursor-pointer"
                    })
                  ]),
                  _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " #TRE0299 ")
                ])
              ], -1)),
              _cache[48] || (_cache[48] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("div", { class: "flex items-center" }, [
                  _createElementVNode("div", { class: "rounded-md w-[40px]" }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: "inline-block rounded-md",
                      alt: "product-image"
                    })
                  ]),
                  _createElementVNode("div", { class: "ltr:ml-[12px] rtl:mr-[12px]" }, [
                    _createElementVNode("span", { class: "block font-medium" }, " Ashley Davis ")
                  ])
                ])
              ], -1)),
              _cache[49] || (_cache[49] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Commercial ")
              ], -1)),
              _cache[50] || (_cache[50] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " 26 Apr 2024 ")
              ], -1)),
              _cache[51] || (_cache[51] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, " $1,500,000 ", -1)),
              _cache[52] || (_cache[52] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "px-[8px] py-[3px] inline-block bg-danger-50 dark:bg-[#15203c] text-danger-600 rounded-sm font-medium text-xs" }, " Rejected ")
              ], -1)),
              _cache[53] || (_cache[53] = _createElementVNode("td", { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }, [
                _createElementVNode("span", { class: "text-gray-500 dark:text-gray-400" }, " Credit Card ")
              ], -1)),
              _createElementVNode("td", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_31, _cache[44] || (_cache[44] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                  ]))), [
                    [_directive_tooltip, 'View']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_32, _cache[45] || (_cache[45] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                  ]))), [
                    [_directive_tooltip, 'Edit']
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_33, _cache[46] || (_cache[46] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                  ]))), [
                    [_directive_tooltip, 'Delete']
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_Pagination, {
        items: "4",
        total: "36",
        class: "px-[20px] md:px-[25px]"
      })
    ])
  ]))
}